import {Customer, CustomerState} from "@/modules/customers/types";
import {ActionTree, GetterTree, Module, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import {
  deleteCustomer, 
  getCustomers, 
  saveCustomer, 
  saveCustomers, 
  updateCustomer,
  getCustomer
} from "@/services/customer";

export const state: CustomerState = {
  customer: {
    name: "",
    address: "",
    tax_id: "",
    email: "",
    company_id: "",
    country_code: "",
    fob: 0,
    exw: 0
  }
}

const actions: ActionTree<CustomerState, RootState> = {
  async GET_CUSTOMER(_, id) {
    return await getCustomer(id);
  },
  async GET_CUSTOMERS() {
    return await getCustomers();
  },
  async UPDATE_CUSTOMER(_, customer) {
    return await updateCustomer(customer)
  },
  async SAVE_CUSTOMER(_, customer) {
    await saveCustomer(customer);
  },
  async SAVE_CUSTOMERS(_, customers) {
    await saveCustomers(customers);
  },
  async DELETE_CUSTOMER(_, id) {
    await deleteCustomer(id);
  }
}

const mutations: MutationTree<CustomerState> = {
  SET_CUSTOMER(state, customer: Customer) {
    state.customer = customer;
  }
}

const getters: GetterTree<CustomerState, RootState> = {
  CUSTOMER(state): Customer {
    const {customer} = state;
    return {...customer};
  }
}

export const customer: Module<CustomerState, RootState> = {
  state,
  actions,
  getters,
  mutations
}
